<template>
    <b-collapse id="lastsearches" class="mt-2" v-if="this.lastSearches && this.lastSearches.length >0">
      <label><strong>Your last searches</strong></label>
      <b-list-group>
        <b-list-group-item href="#" v-for="s in this.lastSearches.slice().reverse()" v-on:click.prevent="redoSearch(s)">{{s}}</b-list-group-item>
      </b-list-group>
      <b-button class="mt-2 mb-5" v-on:click.prevent="deleteLastSearches">Delete search history</b-button>

    </b-collapse>

</template>

<script>
export default {
  name: 'LastSearches',
  data () {
      return {

      }
  },
  computed: {
    lastSearches () {
      if (this.$store.state.lastSearches ) {
        return this.$store.state.lastSearches;
      } else {
        return '';
      }
    }
  },
  methods: {
    deleteLastSearches () {
      this.$store.commit('deleteLastSearches');
    },
    redoSearch(e) {
      this.$router.push({ query: { q: e } });
      this.$root.$emit('bv::toggle::collapse', 'lastsearches');
    }
  }
}
</script>

<style scoped>
  #lastsearches .list-group {
    max-height: 500px;
    overflow: scroll;
  }
</style>
